import { ClientMessageSchema, GAME_PROTOCOL_VERSION, ServerMessageSchema, } from "./messages.js";
export class ProtocolParseError extends Error {
    causeValue;
    constructor(message, causeValue) {
        super(message);
        this.name = "ProtocolParseError";
        this.causeValue = causeValue;
    }
}
export function encodeClientMessage(message) {
    return JSON.stringify(ClientMessageSchema.parse(message));
}
export function encodeServerMessage(message) {
    return JSON.stringify(ServerMessageSchema.parse(message));
}
export function decodeClientMessage(raw) {
    return decodeWithSchema(ClientMessageSchema, raw, "client");
}
export function decodeServerMessage(raw) {
    return decodeWithSchema(ServerMessageSchema, raw, "server");
}
export function withProtocolVersion(message) {
    return {
        ...message,
        protocolVersion: GAME_PROTOCOL_VERSION,
    };
}
function decodeWithSchema(schema, raw, label) {
    let parsed;
    try {
        parsed = JSON.parse(raw);
    }
    catch {
        throw new ProtocolParseError(`Invalid ${label} protocol JSON.`, raw);
    }
    try {
        return schema.parse(parsed);
    }
    catch {
        throw new ProtocolParseError(`Invalid ${label} protocol message shape.`, parsed);
    }
}
